import React from 'react'

import { List, makeStyles } from '@material-ui/core'

import CustomListItemText from './CustomListItemText'
import ListItemButton from './ListItemButton'

const useStyles = makeStyles((theme) => ({
  listItem: {
    paddingLeft: theme.spacing(12),
    paddingRight: theme.spacing(10),
  },
  listTriangleGapCompensor: {
    width: `calc(100% - ${theme.spacing(5)}px)`,
  },
}))

interface ListItemProps {
  text: string
  onChangeSelected: (itemId: string) => void
  itemId: string
  selectedItemsIds: string[]
  dataHook?: string
}

const ListItem: React.FC<ListItemProps> = ({
  text,
  onChangeSelected,
  itemId,
  selectedItemsIds,
  dataHook,
}) => {
  const classes = useStyles()

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <List disablePadding className={classes.listTriangleGapCompensor} data-hook={dataHook || ''}>
      <ListItemButton
        className={classes.listItem}
        selected={selectedItemsIds?.includes(itemId)}
        onClick={() => onChangeSelected(itemId)}
      >
        <CustomListItemText primary={text} primaryTypographyProps={{ variant: 'subtitle2' }} />
      </ListItemButton>
    </List>
  )
}

export default ListItem
